import {
    connect
} from 'react-redux'
import Fitting1EditSettingsComponent from '../components/Fitting1EditSettingsComponent.jsx';
import {
    changeOrderDetailBespokeValue,
    editOrderDetailBespoke
} from '../actions';

const mapStateToProps = (state) => ({
    orderId: state.getIn(['fitting1Reducer', 'orderId']),
    orderDetailList: state.getIn(['orderDetailBespokeListReducer', 'orderDetailList']),
    orderDetail: state.getIn(['fitting1Reducer', 'orderDetail']),
    orderDetailValidation: state.getIn(['fitting1Reducer', 'orderDetailValidation']),
    alertStyle: state.getIn(['fitting1Reducer', 'alertStyle']),
    alertMessage: state.getIn(['fitting1Reducer', 'alertMessage']),
})

const mapDispatchToProps = (dispatch) => ({
    setValue: (id, value) => {
        dispatch(changeOrderDetailBespokeValue({
            id: id,
            value: value
        }))
    },
    editOrderDetail: (orderDetail) => {
        dispatch(editOrderDetailBespoke(orderDetail));
    },
})

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
    orderId: stateProps.orderId,
    orderDetailList: stateProps.orderDetailList,
    orderDetail: stateProps.orderDetail,
    orderDetailValidation: stateProps.orderDetailValidation,
    alertStyle: stateProps.alertStyle,
    alertMessage: stateProps.alertMessage,
    setValue: dispatchProps.setValue,
    editOrderDetail: () => dispatchProps.editOrderDetail(stateProps.orderDetail)
})

const Fitting1EditSettingsContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(Fitting1EditSettingsComponent)

export default Fitting1EditSettingsContainer;


// WEBPACK FOOTER //
// ./src/containers/Fitting1EditSettingsContainer.jsx